<template>
  <div class="handout-picker-shell">
    <header class="handout-picker-header">
      <el-button type="text" icon="el-icon-arrow-left" @click="goBack">返回讲义</el-button>
      <div class="handout-picker-heading">
        <span class="handout-picker-title">从题库添加题目</span>
        <span v-if="handoutTitle" class="handout-picker-sub">{{ handoutTitle }}</span>
      </div>
      <span v-if="existingQuestionIds.length" class="handout-picker-meta">讲义已有 {{ existingQuestionIds.length }} 题</span>
    </header>
    <QuestionList
      v-if="ready"
      picker-mode
      :handout-id="handoutId"
      :existing-question-ids="existingQuestionIds"
      :initial-grade-id="initialGradeId"
      :initial-subject-id="initialSubjectId"
      class="handout-picker-list"
    />
    <div v-else v-loading="true" class="handout-picker-loading" />
  </div>
</template>

<script>
import apiContext from '../../mixins/apiContext'
import QuestionList from '../question/List.vue'
import { extractHandoutFromResponse } from '../../utils/handoutPreviewCache'

export default {
  name: 'HandoutQuestionPicker',
  components: { QuestionList },
  mixins: [apiContext],
  data() {
    return {
      ready: false,
      handoutTitle: '',
      existingQuestionIds: [],
      initialGradeId: null,
      initialSubjectId: null
    }
  },
  computed: {
    handoutId() {
      return this.$route.params.id
    },
    handoutBasePath() {
      return this.isTeacherMode ? '/teacher/handout' : '/handout'
    }
  },
  created() {
    this.loadHandoutMeta()
  },
  methods: {
    goBack() {
      this.$router.push(`${this.handoutBasePath}/${this.handoutId}`)
    },
    loadHandoutMeta() {
      Promise.all([
        this.api.get(`/handout/${this.handoutId}`),
        this.api.get(`/handout/${this.handoutId}/questions`)
      ]).then(([detailRes, questions]) => {
        const handout = extractHandoutFromResponse(detailRes)
        this.handoutTitle = (handout && handout.title) || ''
        this.initialGradeId = handout && handout.gradeId ? Number(handout.gradeId) : null
        this.initialSubjectId = handout && handout.subjectId ? Number(handout.subjectId) : null
        this.existingQuestionIds = (questions || []).map(q => q.id)
        this.ready = true
      }).catch(() => {
        this.$message.error('加载讲义信息失败')
        this.goBack()
      })
    }
  }
}
</script>

<style scoped>
.handout-picker-shell {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f0f2f5;
  overflow: hidden;
}
.handout-picker-header {
  height: 52px;
  padding: 0 20px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}
.handout-picker-heading {
  display: flex;
  align-items: baseline;
  gap: 10px;
  min-width: 0;
}
.handout-picker-title {
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
}
.handout-picker-sub {
  font-size: 13px;
  color: #6b7280;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.handout-picker-meta {
  margin-left: auto;
  font-size: 12px;
  color: #9ca3af;
}
.handout-picker-list {
  flex: 1;
  min-height: 0;
}
.handout-picker-loading {
  flex: 1;
}
</style>

<style>
.handout-picker-list.page-wrap,
.handout-picker-list .page-wrap {
  height: 100%;
  min-height: 0;
}
</style>
